"use client";

import {
  Avatar,
  Card,
  darken,
  rgba,
  Text,
  useMantineTheme,
} from "@mantine/core";

export default function SchoolBranding({
  name,
  imageName,
}: {
  name: string;
  imageName: string;
}) {
  const theme = useMantineTheme();

  const cardBackground = `url(/static/images/schools/${imageName}.png), linear-gradient(to bottom, ${rgba(
    darken(theme.colors.darkblue[9], 0.6),
    0.6
  )}, ${darken(theme.colors.darkblue[9], 0.8)})`;

  return (
    <Card
      p={"xl"}
      radius="lg"
      shadow="md"
      mt={"lg"}
      bgsz={"cover"}
      bgp={"center"}
      style={{
        background: cardBackground,
        border: `1px solid ${theme.colors.dark[3]}`,
        backgroundBlendMode: "overlay",
      }}
    >
      <Avatar
        src={`/static/images/schools/logos/${imageName}Logo.png`}
        size={70}
        radius={70}
        mx="auto"
        p={"sm"}
        bg={"white"}
        style={{
          borderRadius: theme.radius.lg,
        }}
        alt={`${name} school logo`}
      />
      <Text size="lg" ta="center" fw={500} mt="md" c="gray.2">
        {name}
      </Text>
    </Card>
  );
}
